var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"new-article-details"},[_c('div',{staticClass:"new-article-details-box",domProps:{"innerHTML":_vm._s(_setup.detail.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }